import { render, staticRenderFns } from "./CompareLoansList.vue?vue&type=template&id=40408b56&scoped=true&"
import script from "./CompareLoansList.vue?vue&type=script&lang=js&"
export * from "./CompareLoansList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40408b56",
  null
  
)

export default component.exports